// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'circle-mixed-down';

export const Component = () => (
  <path d='M5.873 4.873C7.79 2.958 10.088 2 12.818 2c2.73 0 5.029.958 6.944 2.873 1.916 1.916 2.874 4.215 2.874 6.945 0 2.73-.958 5.029-2.873 6.944-1.916 1.916-4.215 2.874-6.945 2.874-2.73 0-5.029-.958-6.945-2.873C3.958 16.846 3 14.547 3 11.817c0-2.73.958-5.029 2.873-6.945Zm15.757 6.945c0-2.442-.862-4.502-2.539-6.226-1.724-1.724-3.83-2.586-6.274-2.586-2.443 0-4.55.862-6.274 2.586-1.724 1.724-2.586 3.784-2.586 6.226H21.63Z' />
);

export const viewBox = '0 0 25 25';
